'use es6';

import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Image } from 'foundations-components/transitional/components/Image';
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { isResolved } from 'reference-resolvers/utils';
import { PERSONA } from 'reference-resolvers/constants/ReferenceObjectTypes';
import * as ReferenceTypes from 'reference-resolvers/schema/ReferenceTypes';
import PortalIdParser from 'PortalIdParser';
import { Metrics } from '../../../monitoring/Metrics';
import { PERSONA_LABEL_CLICK } from '../../../constants/trackingMetrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getPersonaLink = personaId => {
  const personaIdWithoutPrefix = personaId.split('_')[1];
  return `/property-settings/${PortalIdParser.get()}/contact/hs_persona?id=${personaIdWithoutPrefix}`;
};
const PersonaLabel = ({
  persona,
  personaId,
  personaLabel
}) => {
  if (personaId === '@@MISSING@@') {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Image, {
        shape: "circle",
        src: '//hubspot-avatars.s3.amazonaws.com/default-80.png',
        inlineSize: "2rem",
        blockSize: "2rem",
        marginInlineEnd: 200
      }), /*#__PURE__*/_jsxs(Link, {
        disabled: true,
        children: [" ", personaLabel]
      })]
    });
  }
  if (!isResolved(persona)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Image, {
      shape: "circle",
      src: persona.icon.get('src'),
      inlineSize: "2rem",
      blockSize: "2rem",
      marginInlineEnd: 200
    }), /*#__PURE__*/_jsx(Link, {
      href: getPersonaLink(personaId),
      onClick: () => {
        Metrics.counter(PERSONA_LABEL_CLICK).increment();
      },
      children: persona.label
    })]
  });
};
PersonaLabel.propTypes = {
  persona: ReferenceTypes.byId,
  personaId: PropTypes.string.isRequired,
  personaLabel: PropTypes.string.isRequired
};
const providePersona = ResolveReferences((resolvers, {
  personaId
}) => {
  if (personaId === '@@MISSING@@') {
    return {};
  }
  return {
    persona: resolvers[PERSONA].byId(personaId)
  };
});
export default providePersona(PersonaLabel);